import { useEffect } from 'react'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import { useSelector } from 'react-redux'
import { getSessionIdSelector } from '@app/store/session'

export const useLDGroups = () => {
  const client = useLDClient()
  const sessionId = useSelector(getSessionIdSelector)

  useEffect(() => {
    // url param for easy sharing
    const urlParams = new URLSearchParams(window.location.search)
    const urlGroups = urlParams.get('ld_groups')
    // session storage to retain groups while navigating
    urlParams.has('ld_groups') && window.sessionStorage.setItem('ld_groups', urlGroups || '')
    const sessionGroups = window.sessionStorage.getItem('ld_groups')?.split(',') || []
    client?.identify({
      key: sessionId || 'none',
      custom: {
        groups: sessionGroups
      }
    })
  }, [client, sessionId])
}
